module.exports = __webpack_public_path__ + "web-assets/img/circle_friend.4eb79b37.png";